import { Component, Vue } from 'vue-property-decorator'
import { editMessageTemplate } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
@Component({ name: 'sms-template-edit-page' })
export default class SmsTemplateEditPage extends Vue {
  private templateId: any = ''
  private text: any = ''
  created () {
    this.templateId = this.$route.query.id
  }

  private async onSaveClick () {
    const result = await editMessageTemplate({ id: this.templateId, detail: this.text })
    this.$message({ message: '操作成功', type: 'success' })
    TagsViewModule.delView(this.$route)
    this.$router.go(-1)
  }
}
